import { render, staticRenderFns } from "./TotemSettings.vue?vue&type=template&id=71eba463&"
import script from "./TotemSettings.vue?vue&type=script&lang=js&"
export * from "./TotemSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports